import { BaseState, BaseUser, Filter, INITIAL_BASE_STATE, Pagination } from '@iot-platform/models/common';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { AdminBusinessProfilesMembersActions } from '../actions/business-profiles-members.actions';
import { AdminBusinessProfilesActions } from '../actions/business-profiles.actions';

export type State = BaseState<BaseUser, Pagination, Filter>;

export const adapter: EntityAdapter<BaseUser> = createEntityAdapter<BaseUser>({
  selectId: (user: BaseUser) => user.id as string,
  sortComparer: false
});

export const initialState: State = adapter.getInitialState({
  ...INITIAL_BASE_STATE,
  pagination: { currentPage: 0, total: 0, maxPage: 0, hasMore: false, limit: 1000 }
});

export const adminBusinessProfilesMembersFeature = createFeature({
  name: 'adminBusinessProfilesMembers',
  reducer: createReducer(
    initialState,
    on(AdminBusinessProfilesActions.selectOne, AdminBusinessProfilesMembersActions.loadMembersByBusinessProfile, (state) => adapter.removeAll(state)),
    on(AdminBusinessProfilesMembersActions.loadMembersByBusinessProfileSuccess, (state, { members }) => adapter.setAll(members, state)),
    on(AdminBusinessProfilesMembersActions.addMemberToBusinessProfileSuccess, (state, { addedMember }) => adapter.addOne(addedMember, state)),
    on(AdminBusinessProfilesMembersActions.removeMemberFromBusinessProfileSuccess, (state, { removedMember }) => adapter.removeOne(removedMember.id, state)),

    on(
      AdminBusinessProfilesMembersActions.loadMembersByBusinessProfile,
      AdminBusinessProfilesMembersActions.addMemberToBusinessProfile,
      AdminBusinessProfilesMembersActions.removeMemberFromBusinessProfile,
      (state) => ({ ...state, loading: true, loaded: false })
    ),
    on(
      AdminBusinessProfilesMembersActions.loadMembersByBusinessProfileSuccess,
      AdminBusinessProfilesMembersActions.addMemberToBusinessProfileSuccess,
      AdminBusinessProfilesMembersActions.removeMemberFromBusinessProfileSuccess,
      (state) => ({ ...state, loading: false, loaded: true })
    ),
    on(
      AdminBusinessProfilesMembersActions.loadMembersByBusinessProfileFailure,
      AdminBusinessProfilesMembersActions.addMemberToBusinessProfileFailure,
      AdminBusinessProfilesMembersActions.removeMemberFromBusinessProfileFailure,
      (state, { error }) => ({ ...state, error, loading: false, loaded: false })
    )
  )
});
